'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _axwayReactIntl = require('axway-react-intl');

var _axwayReactIntl2 = _interopRequireDefault(_axwayReactIntl);

var _reactBootstrap = require('react-bootstrap');

var _CodeExampleGenerator = require('../../utility/CodeExampleGenerator');

var _CodeExampleGenerator2 = _interopRequireDefault(_CodeExampleGenerator);

var _ExampleRequest = require('./ExampleRequest');

var _ExampleRequest2 = _interopRequireDefault(_ExampleRequest);

var _CodeEditor = require('../CodeEditor');

var _CodeEditor2 = _interopRequireDefault(_CodeEditor);

var _util = require('./util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 *
 */
var MethodExamples = function (_React$Component) {
	_inherits(MethodExamples, _React$Component);

	function MethodExamples(props) {
		_classCallCheck(this, MethodExamples);

		var _this = _possibleConstructorReturn(this, (MethodExamples.__proto__ || Object.getPrototypeOf(MethodExamples)).call(this, props));

		_axwayReactIntl2.default.init(_this);

		_this.extractQueryParameters = _this.extractQueryParameters.bind(_this);
		_this.extractHeaderParams = _this.extractHeaderParams.bind(_this);
		_this.extractBodyParams = _this.extractBodyParams.bind(_this);
		_this.extractFormParams = _this.extractFormParams.bind(_this);

		// Define the comment messages
		_this.comments = {
			curl: _this.intl.formatMsg('This is an example you can run from command line using curl', 'swagger_example_curl_comment'),
			titanium: _this.intl.formatMsg('This is an example you can run using your Titanium app', 'swagger_example_titanium_comment'),
			node: _this.intl.formatMsg('This is an example you can use in your Node.js app', 'swagger_example_node_comment'),
			web: _this.intl.formatMsg('This is an example you can use in your web app', 'swagger_example_web_comment')
		};
		_this.contentTypes = {
			multipart: 'multipart/form-data'
		};
		return _this;
	}

	_createClass(MethodExamples, [{
		key: 'extractQueryParameters',
		value: function extractQueryParameters() {
			var _props = this.props,
			    query = _props.query,
			    doc = _props.doc,
			    path = _props.path,
			    verb = _props.verb;

			var parameters = (0, _util.getParametersForMethod)(doc, path, verb, ['query']);

			var hasCustomQuery = !!Object.keys(query).length;
			var swaggerHasQuery = parameters && parameters.length;

			if (!swaggerHasQuery && !hasCustomQuery) {
				return '';
			}

			var queryParams = [];
			if (swaggerHasQuery) {
				queryParams = hasCustomQuery ? (0, _util.getDefaultOrOverriddenValuesFromSwagger)(parameters, query) : (0, _util.getDefaultValuesFromSwagger)(parameters);
			}

			// Add custom query parameters not from swagger definition

			var _loop = function _loop(param) {
				if (!queryParams.find(function (p) {
					return p.name === param;
				})) {
					queryParams.push({
						name: param,
						value: query[param]
					});
				}
			};

			for (var param in query) {
				_loop(param);
			}

			return queryParams.map(function (param) {
				if (Array.isArray(param.value)) {
					return (0, _util.buildArrayQueryString)(param, param.value);
				} else {
					return param.name + '=' + param.value;
				}
			})
			// filter out empty params
			.filter(function (p) {
				return !!p;
			}).join('&');
		}
	}, {
		key: 'extractHeaderParams',
		value: function extractHeaderParams() {
			var _props2 = this.props,
			    header = _props2.header,
			    doc = _props2.doc,
			    path = _props2.path,
			    verb = _props2.verb;

			var parameters = (0, _util.getParametersForMethod)(doc, path, verb, ['header', 'consumes', 'produces']);

			var hasCustomHeaders = !!Object.keys(header).length;
			var swaggerHasHeaders = parameters && parameters.length;

			if (!swaggerHasHeaders && !hasCustomHeaders) {
				return [];
			}

			var headerParams = [];
			if (swaggerHasHeaders) {
				headerParams = hasCustomHeaders ? (0, _util.getDefaultOrOverriddenValuesFromSwagger)(parameters, header) : (0, _util.getDefaultValuesFromSwagger)(parameters);
			}

			// Add custom header parameters not from swagger definition

			var _loop2 = function _loop2(param) {
				if (!headerParams.find(function (p) {
					return p.name === param;
				})) {
					headerParams.push({
						name: param,
						value: header[param]
					});
				}
			};

			for (var param in header) {
				_loop2(param);
			}
			return headerParams;
		}
	}, {
		key: 'extractBodyParams',
		value: function extractBodyParams() {
			var _props3 = this.props,
			    doc = _props3.doc,
			    path = _props3.path,
			    verb = _props3.verb,
			    body = _props3.body;

			var parameters = (0, _util.getParametersForMethod)(doc, path, verb, 'body');
			var result = '';

			var hasCustomBody = body && !!Object.keys(body).length;
			var swaggerHasBody = parameters && parameters.length;

			if (!swaggerHasBody && !hasCustomBody) {
				return null;
			}

			if (parameters.length !== 1) {
				throw new Error('Invalid body parameters definition.');
			}

			if (hasCustomBody) {
				result = body;
			} else {
				var bodySchema = (0, _util.deref)(doc, parameters[0].schema);

				// Filter out the readOnly params.
				if (bodySchema.properties) {
					bodySchema.properties = Object.keys(bodySchema.properties).filter(function (p) {
						return !bodySchema.properties[p].readOnly;
					}).reduce(function (col, cur) {
						col[cur] = bodySchema.properties[cur];
						return col;
					}, {});
				}

				result = (0, _util.getDefaultsFromJSONSchema)(bodySchema);
			}

			return result;
		}
	}, {
		key: 'extractFormParams',
		value: function extractFormParams() {
			var _props4 = this.props,
			    form = _props4.form,
			    doc = _props4.doc,
			    path = _props4.path,
			    verb = _props4.verb;

			var parameters = (0, _util.getParametersForMethod)(doc, path, verb, ['formData']);

			var hasCustomFormData = !!Object.keys(form).length;
			var swaggerHasFormData = parameters && parameters.length;

			if (!swaggerHasFormData && !hasCustomFormData) {
				return null;
			}

			var formExamples = swaggerHasFormData ? (0, _util.getDefaultValuesFromSwagger)(parameters) : [];
			var formParams = {};
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = formExamples[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var _ref = _step.value;
					var name = _ref.name,
					    value = _ref.value;

					formParams[name] = value;
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			return _extends({}, formParams, form);
		}
	}, {
		key: 'render',
		value: function render() {
			var _props5 = this.props,
			    heading = _props5.heading,
			    method = _props5.method,
			    scheme = _props5.scheme,
			    doc = _props5.doc,
			    path = _props5.path;

			var url = scheme + '://' + doc.host + doc.basePath + path;
			var queryParams = this.extractQueryParameters();
			url = queryParams ? url + '?' + queryParams : url;
			var headerParams = this.extractHeaderParams();
			var bodyParams = this.extractBodyParams();
			var formParams = this.extractFormParams();
			var generator = _CodeExampleGenerator2.default.from(_ExampleRequest2.default.from({
				method: this.props.verb,
				url: url,
				headers: headerParams,
				body: bodyParams || formParams
			}));

			return _react2.default.createElement(
				'div',
				{ className: 'ux-container examples', key: 'Examples' },
				_react2.default.createElement(
					'h4',
					null,
					heading
				),
				_react2.default.createElement(
					_reactBootstrap.Col,
					{ className: 'content examples nested-tabs', xs: 12 },
					_react2.default.createElement(
						_reactBootstrap.Tabs,
						{ animation: false, className: 'axui', id: 'method-examples-tabs-' + method.operationId },
						_react2.default.createElement(
							_reactBootstrap.Tab,
							{ eventKey: '1', key: '1', title: this.intl.formatMsg('curl') },
							_react2.default.createElement(_CodeEditor2.default, { code: generator.generate('curl', this.comments.curl), mode: 'shell', readOnly: true })
						),
						_react2.default.createElement(
							_reactBootstrap.Tab,
							{ eventKey: '2', key: '2', title: this.intl.formatMsg('Titanium') },
							_react2.default.createElement(_CodeEditor2.default, { code: generator.generate('titanium', this.comments.titanium), mode: 'javascript', readOnly: true })
						),
						_react2.default.createElement(
							_reactBootstrap.Tab,
							{ eventKey: '3', key: '3', title: this.intl.formatMsg('Node.js') },
							_react2.default.createElement(_CodeEditor2.default, { code: generator.generate('node', this.comments.node), mode: 'javascript', readOnly: true })
						),
						_react2.default.createElement(
							_reactBootstrap.Tab,
							{ eventKey: '4', key: '4', title: this.intl.formatMsg('web.js') },
							_react2.default.createElement(_CodeEditor2.default, { code: generator.generate('web', this.comments.web), mode: 'javascript', readOnly: true })
						)
					)
				)
			);
		}
	}]);

	return MethodExamples;
}(_react2.default.Component);

MethodExamples.propTypes = {
	/**
  * Valid swagger 2.0 document
  */
	doc: _propTypes2.default.object.isRequired,

	/**
  * Method examples heading
  */
	heading: _propTypes2.default.string.isRequired,

	/**
  * Swagger 2.0 method
  */
	method: _propTypes2.default.object.isRequired,

	/*
 * The verb containing the parameters to display
 */
	verb: _propTypes2.default.string.isRequired,

	/*
 * The path containing the parmeters to display
 */
	path: _propTypes2.default.string.isRequired,

	/*
 * The scheme used for this definition
 */
	scheme: _propTypes2.default.string.isRequired,

	/*
  * Passed query params as key value pairs
  */
	query: _propTypes2.default.object,

	/*
  * Passed header params as key value pairs
  */
	header: _propTypes2.default.object,

	/*
  * Passed body params as object
  */
	body: _propTypes2.default.object,

	/*
  * Passed form data params as object
  */
	form: _propTypes2.default.object
};

MethodExamples.defaultProps = {
	query: {},
	header: {},
	body: {},
	form: {}
};

var _default = (0, _reactIntl.injectIntl)(MethodExamples);

exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(MethodExamples, 'MethodExamples', 'src/components/SwaggerUI/MethodExamples.jsx');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/SwaggerUI/MethodExamples.jsx');
}();

;